export const faqArray = [
  {
    question: "1. What is CO2 emissions calculation?",
    answer: "CO2 emissions calculation is a process that allows you to assess your contribution to carbon dioxide emissions in the atmosphere through your daily activities."
  },
  {
    question: "2. Why Should You Calculate CO2 Emissions?",
    answer: "Reducing CO2 emissions is crucial for slowing down climate change and preserving the environment for future generations. Here are some key statistics:",
    subItems: [
      "CO2 emissions contribute to global warming and climate change.",
      "Transportation and energy consumption are major sources of emissions.",
      "By reducing emissions, we can enjoy cleaner air, a more stable climate, and healthier ecosystems."
    ]
  },
  {
    question: "3. What benefits does emissions reduction offer?",
    answer: "Reducing CO2 emissions helps slow down climate change and preserve the environment for future generations. It can lead to cleaner air, a more stable climate, and healthier ecosystems."
  },
  {
    question: "4. How can I contribute?",
    answer: "By using the application, you can estimate your emissions and discover ways to make small changes to reduce them. Even small actions, when collective, make a significant difference."
  },
  {
    question: "5. How Can Carbon Footprint Help You?",
    answer: "Our application is designed to provide practical solutions for a more sustainable lifestyle:",
    subItems: [
      "Plan eco-friendly travel by calculating the emissions of your trips.",
      "Understand your carbon footprint and discover ways to reduce it.",
      "Explore scenarios to see the impact of lifestyle changes on emissions."
    ]
  },
  {
    question: "6. What are some everyday actions that can help reduce CO2 emissions?",
    answer: "Reducing CO2 emissions starts with small everyday actions. Here are some steps you can take to reduce your carbon footprint:",
    subItems: [
      "Use public transportation: Opt for public transportation, carpooling, or biking instead of driving alone in your car.",
      "Conserve energy: Turn off lights and appliances when not in use, use energy-efficient light bulbs, and properly insulate your home.",
      "Reduce, reuse, recycle: Practice the three Rs to reduce waste and conserve resources.",
      "Support renewable energy: If possible, switch to renewable energy sources like solar or wind power.",
      "Plant trees: Trees absorb CO2 and can help offset your emissions.",
      "Buy local and sustainable: Support local and sustainable products and reduce the carbon footprint of your food and goods."
    ]
  }
];